import { Result } from 'antd';

import { Spinner } from '@/v1/main/views/Spin';

export const PageLoading: React.FC = () => {
    return <Result icon={<Spinner />} />;
};
